import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import {
  SearchPageContainer,
  SearchContentWrapper,
  SearchBoxContainer,
  StyledSearchBox,
  SearchIcon,
  SectionTitle,
  TagContainer,
  HistoryTag,
  HotTag,
  EmptyState,
  ClearHistoryButton,
  TitleRow
} from '../../components/Search/styles';

const hotKeywords = ['Burton', '女款', '硬度7', '公园', 'Nitro', '刻滑', '男款'];
const getHistory = () => JSON.parse(localStorage.getItem('searchHistory') || '[]');

const SearchPage = () => {
  const [value, setValue] = useState('');
  const [history, setHistory] = useState(getHistory());
  const navigate = useNavigate();

  const onSearch = (val) => {
    const searchValue = val || value;
    if (!searchValue) return;
    const newHistory = [searchValue, ...history.filter(h => h !== searchValue)].slice(0, 8);
    setHistory(newHistory);
    localStorage.setItem('searchHistory', JSON.stringify(newHistory));
    
    // 跳转到产品列表页面并传递搜索参数，添加from=search标识搜索模式
    navigate(`/products?searchtext=${encodeURIComponent(searchValue)}&from=search`);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  const handleIconClick = () => {
    onSearch();
  };

  const clearHistory = () => {
    setHistory([]);
    localStorage.removeItem('searchHistory');
  };

  const handleTagClick = (keyword) => {
    setValue(keyword);
    onSearch(keyword);
  };

  return (
    <SearchPageContainer>
      <SearchContentWrapper>
        <SearchBoxContainer>
          <SearchIcon onClick={handleIconClick} />
          <StyledSearchBox
            placeholder="搜索装备/品牌/型号/性别/颜色/技术信息..."
            value={value}
            onChange={e => setValue(e.target.value)}
            onKeyPress={handleKeyPress}
            size="large"
            autoFocus
          />
        </SearchBoxContainer>

        <TitleRow>
          <SectionTitle level={5}>历史搜索</SectionTitle>
          {history.length > 0 && (
            <ClearHistoryButton onClick={clearHistory}>
              清除历史
            </ClearHistoryButton>
          )}
        </TitleRow>
        
        <TagContainer>
          {history.length === 0 ? (
            <EmptyState>暂无搜索历史</EmptyState>
          ) : (
            history.map(h => (
              <HistoryTag 
                key={h} 
                onClick={() => handleTagClick(h)}
              >
                {h}
              </HistoryTag>
            ))
          )}
        </TagContainer>

        <SectionTitle level={5}>热门搜索</SectionTitle>
        <TagContainer>
          {hotKeywords.map(hot => (
            <HotTag 
              key={hot} 
              onClick={() => handleTagClick(hot)}
            >
              {hot}
            </HotTag>
          ))}
        </TagContainer>
      </SearchContentWrapper>
    </SearchPageContainer>
  );
};

export default SearchPage;